(function () {
  "use strict";

  angular.module("appback").controller("InboxController", InboxController);

  InboxController.$inject = ["$http"];

  function InboxController($http) {
    var vm = this;

    vm.conversations = [];
    vm.messagesByConversation = {};
    vm.contactsByConversation = {};
    vm.opportunitiesByConversation = {};
    vm.insightsByConversation = {};

    vm.selectedConversation = null;
    vm.messages = [];
    vm.contact = null;
    vm.opportunity = null;
    vm.aiInsights = null;

    vm.filter = "all";
    vm.searchQuery = "";
    vm.replyText = "";

    vm.newRecord = newRecord;
    vm.setFilter = setFilter;
    vm.filteredConversations = filteredConversations;
    vm.unreadCount = unreadCount;
    vm.selectConversation = selectConversation;
    vm.sendReply = sendReply;
    vm.discardReply = discardReply;
    vm.useSuggestedReply = useSuggestedReply;
    vm.dismissInsight = dismissInsight;
    vm.runSmartAction = runSmartAction;

    activate();

    function activate() {

      $http.get("data/inbox-conversations.json").then(function (res) {
        vm.conversations = res.data;
        if (vm.conversations.length) {
          selectConversation(vm.conversations[0]);
        }
      });

      $http.get("data/inbox-messages.json").then(function (res) {
        vm.messagesByConversation = res.data;
        syncSelection();
      });

      $http.get("data/inbox-contact.json").then(function (res) {
        vm.contactsByConversation = res.data;
        syncSelection();
      });

      $http.get("data/inbox-opportunity.json").then(function (res) {
        vm.opportunitiesByConversation = res.data;
        syncSelection();
      });

      $http.get("data/inbox-ai-insights.json").then(function (res) {
        vm.insightsByConversation = res.data;
        syncSelection();
      });
    }

    function syncSelection() {
      if (vm.selectedConversation) {
        selectConversation(vm.selectedConversation);
      }
    }

    function newRecord() {
      window.alert("Opening new record wizard...");
    }

    function setFilter(filter) {
      vm.filter = filter;
    }

    function filteredConversations() {
      var query = (vm.searchQuery || "").toLowerCase().trim();

      return vm.conversations.filter(function (conv) {
        if (vm.filter === "unread" && !conv.unread) {
          return false;
        }
        if (vm.filter === "ai" && !conv.aiReview) {
          return false;
        }
        if (!query) {
          return true;
        }
        return (
          conv.name.toLowerCase().indexOf(query) !== -1 ||
          conv.company.toLowerCase().indexOf(query) !== -1 ||
          conv.preview.toLowerCase().indexOf(query) !== -1
        );
      });
    }

    function unreadCount() {
      return vm.conversations.filter(function (conv) {
        return conv.unread;
      }).length;
    }

    function selectConversation(conv) {
      vm.selectedConversation = conv;
      conv.unread = false;
      vm.messages = vm.messagesByConversation[conv.id] || [];
      vm.contact = vm.contactsByConversation[conv.id] || null;
      vm.opportunity = vm.opportunitiesByConversation[conv.id] || null;
      vm.aiInsights = vm.insightsByConversation[conv.id] || null;
      vm.replyText = "";
    }

    function sendReply() {
      if (!vm.replyText || !vm.replyText.trim() || !vm.selectedConversation) {
        return;
      }

      vm.messages.push({
        type: "agent",
        sender: "You",
        time: currentTime(),
        channelIcon: vm.selectedConversation.channelIcon,
        text: vm.replyText
      });

      vm.selectedConversation.preview = vm.replyText;
      vm.replyText = "";
    }

    function discardReply() {
      vm.replyText = "";
    }

    function useSuggestedReply() {
      if (vm.aiInsights && vm.aiInsights.recommendation) {
        vm.replyText = vm.aiInsights.recommendation.suggestedReply || vm.replyText;
      }
    }

    function dismissInsight() {
      vm.aiInsights = null;
    }

    function runSmartAction(action) {
      window.alert(action.label + " triggered.");
    }

    function currentTime() {
      var now = new Date();
      var hours = now.getHours() % 12 || 12;
      var minutes = now.getMinutes();
      var ampm = now.getHours() >= 12 ? "PM" : "AM";
      return hours + ":" + (minutes < 10 ? "0" : "") + minutes + " " + ampm;
    }
  }
})();
